import { TopicCluster } from 'ha/modules/Hermes/types';

import { defineKey as T } from 'ha/i18n';

export const TOPIC_CLUSTER_LABEL: {
  [key in TopicCluster]: string;
} = {
  rentingAbroad: T('community.categories.rentingAbroad'),
  movingAbroad: T('community.categories.movingAbroad'),
  livingIn: T('community.categories.livingIn'),
  studying: T('community.categories.studying'),
  working: T('community.categories.working'),
};
